import { useEffect, useState } from "react";
import { Video, Timer } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");
export const apptStart = (a) => a.start || new Date(`${a.date}T${a.time}:00`).getTime();
export const nextCall = (items) => (items || []).filter((a) => apptStart(a) + (a.duration || 30) * 60000 > Date.now()).sort((x, y) => apptStart(x) - apptStart(y))[0];

const romeDay = (ms) => new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Rome" }).format(new Date(ms));

export function CallReminder({ appt }) {
  if (!appt) return null;
  const start = apptStart(appt);
  const now = Date.now();
  if (now >= start) return null;
  const today = romeDay(now);
  const day = romeDay(start);
  const tomorrow = romeDay(now + 86400000);
  if (day !== today && day !== tomorrow) return null;
  return (
    <div className="mb-4 rounded-2xl border border-[#d4af37]/50 bg-gradient-to-br from-[#13254a] to-[#0a1428] p-4" data-testid="call-reminder">
      <div className="text-sm font-bold text-[#f1d78a]">{day === today ? "Oggi" : "Domani"} hai la videochiamata con il coach alle ore {appt.time}</div>
      <div className="mt-1 text-xs text-slate-300">Se non riesci a esserci, spostala ora così il posto si libera per altri.</div>
      {appt.rescheduleUrl && (
        <a href={appt.rescheduleUrl} target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-1.5 rounded-xl border border-[#d4af37]/60 px-4 py-2 text-xs font-bold text-[#f1d78a] hover:bg-[#d4af37]/10" data-testid="call-reminder-reschedule">Sposta appuntamento</a>
      )}
    </div>
  );
}

export default function CallCountdown({ appt, compact }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);
  if (!appt) return null;
  const start = apptStart(appt);
  const end = start + (appt.duration || 30) * 60000;
  if (now > end) return null;
  const s = Math.max(0, Math.floor((start - now) / 1000));
  const live = now >= start;
  const joinable = !!appt.meetLink && now >= start - 10 * 60000;
  const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
  const label = live ? "In corso" : d ? `${d}g ${pad(h)}:${pad(m)}:${pad(sec)}` : `${pad(h)}:${pad(m)}:${pad(sec)}`;
  return (
    <div className={`flex items-center gap-3 rounded-2xl border border-[#d4af37]/50 bg-[#d4af37]/10 p-4 ${joinable ? "gold-pulse" : ""} ${compact ? "mt-3" : "mb-4"}`} data-testid="call-countdown">
      <Timer className="h-6 w-6 shrink-0 text-[#d4af37]" />
      <div className="min-w-0 flex-1">
        <div className="text-xs text-slate-300">{live ? "La videochiamata è iniziata" : "Videochiamata con il coach tra"}</div>
        <div className="font-mono-num text-xl font-extrabold text-[#f1d78a]" data-testid="call-countdown-time">{label}</div>
      </div>
      {joinable ? (
        <a href={appt.meetLink} target="_blank" rel="noreferrer" className="inline-flex shrink-0 items-center gap-1.5 rounded-xl bg-gradient-to-r from-[#d4af37] to-[#f1d78a] px-3 py-2 text-xs font-extrabold text-[#0a1428]" data-testid="call-join-now"><Video className="h-4 w-4" /> Entra ora</a>
      ) : !compact && <span className="shrink-0 text-[10px] text-slate-400">Il tasto si attiva 10 min prima</span>}
    </div>
  );
}
